import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OverviewPageModule } from '@com-delta-idp/mnx-skymiles-overview-ui';
import { WelcomeTourModule } from '@com-delta-idp/mnx-skymiles-shared';
import { SkeletonLoaderDirective } from '@com-delta-omnichannel/aura';
import { PushPipe } from '@ngrx/component';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AmexSkyClubTrackerEffects } from './data-access/+state/effects/amex-skyclub-tracker.effects';
import { ContentEffects } from './data-access/+state/effects/content.effects';
import { DocsEffects } from './data-access/+state/effects/docs.effects';
import { EarnsSummaryEffects } from './data-access/+state/effects/earns-summary.effects';
import { FutureActivityEffects } from './data-access/+state/effects/future-activities.effects';
import { MembershipCardEffects } from './data-access/+state/effects/membership-card.effects';
import { PersonalizationEngineEffects } from './data-access/+state/effects/personalization-engine.effects';
import { SkyClubTrackerEffects } from './data-access/+state/effects/skyclub-tracker.effects';
import { SnapshotEffects } from './data-access/+state/effects/snapshot.effects';
import { SummaryContentEffects } from './data-access/+state/effects/summary-content.effects';
import { TrackerEffects } from './data-access/+state/effects/tracker.effects';
import * as fromOverview from './data-access/+state/reducers/overview.reducer';
import { OverviewComponent } from './entry-components/overview/overview.component';

@NgModule({
  imports: [
    CommonModule,
    OverviewPageModule,
    PushPipe,
    WelcomeTourModule,
    SkeletonLoaderDirective,
    StoreModule.forFeature(
      fromOverview.OVERVIEW_FEATURE_KEY,
      fromOverview.reducer
    ),
    RouterModule.forChild([{ path: '', component: OverviewComponent }]),
    EffectsModule.forFeature([
      ContentEffects,
      DocsEffects,
      MembershipCardEffects,
      PersonalizationEngineEffects,
      SnapshotEffects,
      TrackerEffects,
      FutureActivityEffects,
      SummaryContentEffects,
      EarnsSummaryEffects,
      SkyClubTrackerEffects,
      AmexSkyClubTrackerEffects
    ])
  ],
  declarations: [OverviewComponent],
  exports: [OverviewComponent]
})
export class SmartModule {}
